export default __webpack_public_path__ + "static/media/lineas.5dffdfff.png";